import React, { useCallback } from 'react';

import { MemoizedLetter } from '../components/MemoizedLetter';
import { Data } from '../types';

import { mergeLetterPdf } from './mergeLetterPdf';

export interface Options {
  isFCRAIncluded: boolean;
}

export interface GenerateLetterFileOptions {
  isFCRAIncluded: boolean;
  openInNewTab: boolean;
}

export async function generateLetterFile(
  data: Data,
  options: GenerateLetterFileOptions,
): Promise<File[]> {
  try {
    return await mergeLetterPdf(<MemoizedLetter data={data} />, {
      hasFcra: options.isFCRAIncluded,
      openInNewTab: options.openInNewTab,
      policyNumber: data.policyNumber,
      letterType: data.letterType,
    });
  } catch (error) {
    console.error('Error generating PDF:', error);
    throw error;
  }
}

const useGenerate = ({ isFCRAIncluded }: Options) => {
  const generate = useCallback(
    (data: Data) =>
      generateLetterFile(data, { isFCRAIncluded, openInNewTab: true }),
    [isFCRAIncluded],
  );

  return { generate };
};

export default useGenerate;
